import { useEffect } from "react";

import { GTM_CONTAINER_ID } from "~/constants/analytics";

import { loadGoogleTagManager } from "./tagManager";

export const GoogleTagManager = () => {
  useEffect(() => {
    loadGoogleTagManager(GTM_CONTAINER_ID);
  }, []);

  return null;
};
